import axios from '@/axios/index.js'
import common from '@/utils/common.js'

const baseUrl = common.baseUrl


/**
 * 
 * 登录
 * 
 */

export const login = (params) => {
	return axios({
		url: `${baseUrl}/login`,
		method: 'post',
		params,
	})
}


export const loginOut = (params) => {
	return axios({
	  url: `${baseUrl}/logout/${params}`,
	  method: 'get'
	})
  }

  // 用户菜单
export const getUserRouter = (params) => {
	return axios({
		url: `${baseUrl}/base/menu/queryUserMenuRouter`,
		method: 'get',
		params
	})
}



export const getOpenid = (params)=> {
    return axios({
      url: `${baseUrl}/wechat/getOpenid`,
      method: 'get',
      params,
    })
  }

  
  export const buildPaySign = (params)=> {
    return axios({
      url: `${baseUrl}/wechat/buildPaySign`,
      method: 'get',
      params,
    })
  }


  export const orderUpdate = (params) => {
	return axios({
		url: `${baseUrl}/wechat/orderUpdate`,
		method: 'post',
		params,
	})
}


export const orderSubmit = (params) => {
	return axios({
		url: `${baseUrl}/wechat/orderSubmit`,
		method: 'post',
		params,
	})
}




export const storeUploader = (params) => {
	return axios({
		url: `${baseUrl}/store/upload`,
		method: 'post',
		data:params,
	})
}

// 上传广告图片
export const uploadImage = (params) => {
	return axios({
		url: `${baseUrl}/ad/uploadImage`,
		method: 'post',
		data:params,
	})
}

// 上传视频图片
export const uploadVideo = (params) => {
	return axios({
		url: `${baseUrl}/ad/uploadVideo`,
		method: 'post',
		data:params,
	})
}


// 
export const getWechatConfig = (params) => {
	return axios({
		url: `${baseUrl}/wechatConfig/get`,
		method: 'get',
		params
	})
}


export const resetPwd = (params) => {
	return axios({
		url: `${baseUrl}/partner/resetPwd`,
		method: 'get',
		params,
	})
}